import { Card } from '@mui/material';
import { useParams } from 'react-router-dom';
import { POSITION_DETAILS_MATCH_PAGE_FILTERS } from '../../../consts';
import { useGetMatchesByPositionId } from '../../../hooks/useMatch';
import { useGetPositionById } from '../../../hooks/usePositions';
import { useTablePageParams } from '../../../hooks/useTablePageParams';
import PositionDetailsTable from '../PositionDetailsTable';
import PositionDetailsFilters from '../PositionsDetailsFilters';
import PositionStatusesAndTasks from '../PositionStatusesAndTasks';

const style = {
  card: {
    sx: {
      mt: 3,
    },
  },
} as const;

export const AppMatchesTab = ():JSX.Element => {
  const { positionId = '' } = useParams();
  const {
    activeFilters,
    onChangeFilter,
    currentPage,
    onPageChange,
    activeSort,
    onSortChange,
  } = useTablePageParams([
    POSITION_DETAILS_MATCH_PAGE_FILTERS.QUERY,
    POSITION_DETAILS_MATCH_PAGE_FILTERS.MATCH_STATUS,
    POSITION_DETAILS_MATCH_PAGE_FILTERS.ENGAGEMENT_STATUS,
  ]);
  const { position } = useGetPositionById(positionId || '');
  const {
    matches,
    totalCount,
    isLoading,
    refetch,
    setEnableQuery,
  } = useGetMatchesByPositionId(
    positionId || '',
    position?.accountId || '',
    activeFilters,
    currentPage,
    activeSort,
  );

  const handleChangePage = (newPageNumber: number):void => {
    onPageChange(newPageNumber + 1);
  };

  return (
    <>
      <PositionStatusesAndTasks
        positionId={ positionId }
        accountId={ position?.accountId }
      />
      <Card sx={ style.card.sx }>
        <PositionDetailsFilters
          activeFilters={ activeFilters }
          onChangeFilter={ onChangeFilter }
        />
        <PositionDetailsTable
          positionId={ position?.id || '' }
          matches={ matches }
          page={ currentPage - 1 }
          totalCount={ totalCount }
          isLoading={ isLoading }
          order={ activeSort }
          orderHandler={ onSortChange }
          onPageChange={ handleChangePage }
          accountId={ position?.accountId || '' }
          refetchMatches={ refetch }
          setEnableQuery={ setEnableQuery }
        />
      </Card>
    </>
  );
};
